import SubComponent from "./SubComponent";
import { SectionTitle, CmpTable } from "../shared";
import { Helper, COUNTRY_LIST } from "../../utils";
import { ALL_BASIC_LOGIN_CONFIG } from "./query";

const BasicLoginConfigList = () => {
    const columns = [
        {
            accessorKey: "appName",
            header: "App Name",
            cell: (cell) => Helper.getAppNameById(cell.getValue()),
        },
        {
            accessorKey: "rootPath",
            header: "Root Path",
        },
        {
            accessorKey: "domainName",
            header: "Domain Name",
        },
        {
            accessorKey: "isEnabled",
            header: "Enable/Disable",
            cell: (cell) => (cell.getValue() === "1" ? "Enabled" : "Disabled"),
        },
    ];

    const renderSubComponent = (data) => {
        return <SubComponent data={data.row.original} />;
    };
    return (
        <>
            <SectionTitle
                title="Basic Login Config"
                buttonUrl="/global-config/basic-login/create"
                backUrl="/global-config"
            />

            <CmpTable
                QUERY={ALL_BASIC_LOGIN_CONFIG}
                headers={columns}
                renderSubComponent={renderSubComponent}
                dataPath="allBasicAuths"
            />
        </>
    );
};

export default BasicLoginConfigList;
